import { hasModernPreviewAccess } from '@/shells/models/modernPreviewAccess';
import { FORUM_ROUTE_PAIRS, forumExperienceDestination } from './forumExperience';

// Versions of the same tool, not different navigation catalogues. Unported
// tools have no entry and keep their existing route in either experience.
export const CONTENT_VERSIONS = Object.freeze([
  { legacy: 'Stockchart', modern: 'ChartingNext', legacyNames: ['Stockchart', 'StockchartTable'], modernNames: ['ChartingNext', 'ChartingNextEntry'] },
  { legacy: 'NewsIPOs', modern: 'UpcomingIpos', legacyNames: ['NewsIPOs'], modernNames: ['UpcomingIpos'] },
  { legacy: 'informes', modern: 'ReportsNext', legacyNames: ['informes', 'informe-detail'], modernNames: ['ReportsNext', 'ReportNext'] },
  { legacy: 'Exercises', modern: 'ExercisesNext', legacyNames: ['Exercises'], modernNames: ['ExercisesNext', 'ExercisesNextSession'] },
  { legacy: 'Forum', modern: 'ForumNext', legacyNames: [...FORUM_ROUTE_PAIRS.map(pair => pair[0]), 'ForumNewThread'], modernNames: [...FORUM_ROUTE_PAIRS.map(pair => pair[1]), 'ForumNextCreate'] }
]);

export function explicitContentExperience(route = {}) {
  if (CONTENT_VERSIONS.some(tool => tool.modernNames.includes(route.name))) return 'modern';
  if (CONTENT_VERSIONS.some(tool => tool.legacyNames.includes(route.name))) return 'legacy';
  return null;
}

export function availableExperience(experience, user) {
  return experience === 'modern' && hasModernPreviewAccess(user) ? 'modern' : 'legacy';
}

export function contentNavigationItem(item, experience = 'legacy') {
  const tool = CONTENT_VERSIONS.find(version => version.legacy === item.routeName);
  if (!tool) return item;
  return { ...item, routeName: tool[experience], activeNames: [...(item.activeNames || []), ...tool.legacyNames, ...tool.modernNames] };
}

export function experienceDestination(route = {}, experience) {
  const tool = CONTENT_VERSIONS.find(version => [...version.legacyNames, ...version.modernNames].includes(route.name));
  // Switching on an unported page only updates future navigation: do not throw
  // the user back to the chart or discard the page they were working on.
  // An open composer has no interchangeable draft contract. Keep its route;
  // switching only affects the next navigation, never silently discards text.
  if (tool?.legacy === 'Forum') return forumExperienceDestination(route, experience);
  return tool ? { name: tool[experience] } : null;
}
